import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // 使用平滑滚动效果
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop; 